import { options } from '../../config/inspector';

const specificProps = {
  CheckIn: {
    unidentifiedRate: {
      type: 'number',
      label: 'Taux non identifiés',
      group: 'specific',
      path: 'customAttributes/unidentifiedRate',
      min: 0,
      max: 1,
      step: 0.01,
    },
  },
  DropOff: {
    unidentifiedRate: {
      type: 'number',
      label: 'Taux non identifiés',
      group: 'specific',
      path: 'customAttributes/unidentifiedRate',
      min: 0,
      max: 1,
      step: 0.01,
    },
  },
  PrimaryControl: {
    pendingRate: {
      type: 'number',
      label: 'Taux de rejet',
      group: 'specific',
      path: 'customAttributes/pendingRate',
      min: 0,
      max: 1,
      step: 0.01,
    },
  },
  ComplementaryControl: {
    pendingRate: {
      type: 'number',
      label: 'Taux de rejet',
      group: 'specific',
      path: 'customAttributes/pendingRate',
      min: 0,
      max: 1,
      step: 0.01,
    },
  },
  ManualIdentificationPoint: {
    duration: {
      type: 'computed',
      label: 'Durée (calculée)',
      group: 'specific',
      path: 'customAttributes/duration',
      formula: 'Math.round(3600 / capacityPerHour * parallelism)',
      readOnly: true,
    },
  },
  TechnologyExchanger: {
    binMaxInputSize: {
      type: 'number',
      label: 'Stock max de bacs',
      group: 'specific',
      path: 'customAttributes/binMaxInputSize',
      min: 1,
      required: true,
    },
    unloadingModule: {
      type: 'select-box',
      label: 'Module de déchargement',
      group: 'specific',
      options: () => options.modules,
      path: 'customAttributes/UnloadingModule',
      defaultValue: '',
      required: true,
    },
  },
  LoadingStation: {
    binMaxInputSize: {
      type: 'number',
      label: 'Stock max de bacs',
      group: 'specific',
      path: 'customAttributes/binMaxInputSize',
      min: 1,
      required: true,
    },
  },
  Sorter: {
    recirculationRate: {
      type: 'number',
      label: 'Taux de recirculation',
      group: 'specific',
      path: 'customAttributes/recirculationRate',
      min: 0,
      max: 1,
      step: 0.01,
    },
    maxRecirculations: {
      type: 'number',
      label: 'Recirculations max',
      group: 'specific',
      path: 'customAttributes/maxRecirculations',
      min: 1,
      required: true,
    },
    theoreticalNumberOfPlaces: {
      type: 'number',
      label: 'Nombre de places théorique',
      group: 'specific',
      path: 'customAttributes/theoreticalNumberOfPlaces',
      min: 1,
      required: true,
    },
    loadFactor: {
      type: 'number',
      label: 'Facteur de charge',
      group: 'specific',
      path: 'customAttributes/loadFactor',
      min: 0,
      max: 1,
      step: 0.01,
      required: true,
    },
  },
  Tri: {
    sens: {
      type: 'select-box',
      label: 'Sens de rotation',
      group: 'specific',
      path: 'sens',
      options: [
        { value: false, content: 'Horaire' },
        { value: true, content: 'Anti-horaire' },
      ],
      defaultValue: false,
    },
    ports: {
      type: 'ports-editor',
      label: 'Ports',
      group: 'specific',
      path: 'ports/items',
    },
  },
};
export default function getSpecificProperties(subType) {
  return specificProps[subType] || {};
}
